import types from '@/store/types/utils'
import Vue from 'vue';
import moment from 'moment';
import { hora1MayorAHora2 } from '@/libs/utils/validaciones'
const state = {
  dialogo: {
    abrirPeNoEnviados: false,
    abrirPeEnviados: false,
    abrirDesistimientosPe: false,
    abrirDesistimientosAmpl: false,
    abrirAmpliacionesEnviadas: false,
    abrirDocsPostNoEnviados: false,
    abrirDocsPostEnviados: false,
    abrirOrdenFiscaNoEnviados: false,
    abrirOrdenFiscaEnviados: false,
    abrirInclusionExclusionEnviados: false,
    abrirAclaracionCompEnm: false
  },
  dialogProgress: false,
  dialogProgressLabel: 'Procesando...',
  oficinas: [],
  objRequisitoTramite: {}
}
const getters = {

  [types.getters.Getdialogo]: (state) => {
    return state.dialogo;
  },
  [types.getters.GetdialogProgress]: (state) => {
    return state.dialogProgress;
  },
  [types.getters.GetdialogProgressLabel]: (state) => {
    return state.dialogProgressLabel;
  },
  [types.getters.GetOficinas]: (state) => {
    return state.oficinas;
  },
  [types.getters.GetRequisitoTramite]: (state) => {
    return state.objRequisitoTramite;
  }
}
const mutations = {

  [types.mutations.Setdialogo]: (state, obj) => {
    state.dialogo = obj;
  },
  [types.mutations.SetdialogProgress]: (state, dialogProgress) => {
    state.dialogProgress = dialogProgress;
    if (!dialogProgress) {
      setTimeout(() => {
        state.dialogProgressLabel = 'Procesando...';
      }, 500)
    }
  },
  [types.mutations.SetOpenProgressWithMessage]: (state, dialogProgressLabel) => {
    state.dialogProgress = true;
    state.dialogProgressLabel = dialogProgressLabel;
  },
  [types.mutations.SetOficinas]: (state, lstOficinas) => {
    state.oficinas = lstOficinas;
  },
  [types.mutations.SetRequisitoTramite]: (state, obj) => {
    state.objRequisitoTramite = obj;
  }
}
const actions = {
  [types.actions.ObtenerFechaServidor]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get(`consultas/fecha_servidor`).then(r => {
        resolve(r);
      })
    })
  },
  [types.actions.ObtenerOficinas]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get(`oficinas/list`).then(r => {
        commit(types.mutations.SetOficinas, r.data);
        resolve(r);
      })
    })
  },
  [types.actions.VerificarHoras]: ({ commit }, pOficinaID) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get(`consultas/fecha_servidor`).then(responseHoraActual => {
        Vue.prototype.$http.get(`dominio/horarioAtencion/${pOficinaID}/${process.env.VUE_APP_SUSBSISTEMA}`).then(responseHoraAtencion => {
          let horaActualServidor = moment(responseHoraActual.data).format('HH:mm:ss');
          const horaAtencion = responseHoraAtencion.data[responseHoraAtencion.data.length - 1].horaFin;
          let cadena = '';
          if (hora1MayorAHora2(horaActualServidor, horaAtencion)) {
            let horaAtencion = '';
            Object.keys(responseHoraAtencion.data).forEach(propiedad => {
              const objeto = responseHoraAtencion.data[propiedad]
              horaAtencion = horaAtencion + objeto.turno.toLowerCase() + ' [' + objeto.horaInicio.substring(0, 5) + ' a ' + objeto.horaFin.substring(0, 5) + ']. '
            });
            cadena = `<br><div class="error--text"><strong>ADVERTENCIA:</strong> Su solicitud se está enviando fuera del horario administrativo de la AJ. Por lo tanto, su trámite será recibido y procesado en el siguiente horario administrativo disponible.<br><strong>HORARIO ADMINISTRATIVO:</strong>  ` + horaAtencion + ` </div>`
          }
          resolve(cadena);
        })
      })
    })
  }
}
export default {
  state,
  actions,
  getters,
  mutations
}
